"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const Adjustments = (props) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "icon icon-tabler icons-tabler-outline icon-tabler-adjustments", ...props },
    React.createElement("path", { d: "M0 0h24v24H0z", stroke: "none" }),
    React.createElement("path", { d: "M4 10a2 2 0 104 0 2 2 0 00-4 0M6 4v4M6 12v8M10 16a2 2 0 104 0 2 2 0 00-4 0M12 4v10M12 18v2M16 7a2 2 0 104 0 2 2 0 00-4 0M18 4v1M18 9v11" }));
exports.default = Adjustments;
